import { PropsWithChildren } from 'react';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { DialogueIcon } from '@treams/treams-icons';
import { Card, IconColor, Paragraph, Subheading, tokens } from '@treams/treams-ui';

import PopoverTarget from '../../packages/kakapo-ui-kit/components/popovers/PopoverTarget';

const Link = styled(Box)`
	cursor: pointer;
	color: ${tokens.text.secondary};
	text-decoration: underline;
	font-size: 14px;
	flex-grow: 0;
	flex-shrink: 0;

	&:hover {
		text-decoration: none;

		&:active {
			color: black;
		}
	}
`;

export default function DashboardCard(
	props: PropsWithChildren<{
		title?: string;
		description?: string;
		link?: string;
		onLinkClick?: () => void;
		explanation?: string;
	}>,
) {
	return (
		<Card>
			{(props.title || props.description) && (
				<Flex>
					<Box pb={0} flexShrink={1} flexGrow={1}>
						{props.title && (
							<Flex mb={2} alignItems="baseline">
								<Subheading>{props.title}</Subheading>
								{props.link && <Link onClick={props.onLinkClick}>{props.link}</Link>}
							</Flex>
						)}
						{props.description && <Paragraph mb={2}>{props.description}</Paragraph>}
					</Box>
					{props.explanation && (
						<Box py={3} pr={3} flexShrink={0} flexGrow={0}>
							<PopoverTarget
								content={
									<Box p={3}>
										<Paragraph>{props.explanation}</Paragraph>
									</Box>
								}
							>
								<Box size={24} flexShrink={0} flexGrow={0}>
									<IconColor color="slateBlue">
										<DialogueIcon />
									</IconColor>
								</Box>
							</PopoverTarget>
						</Box>
					)}
				</Flex>
			)}
			{props.children}
		</Card>
	);
}
